import type { OrderDeliveryEvidenceResponseType } from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  apiV2Request,
  getDefaultQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useOrderDeliveryEvidence = (
  orderId: number,
  { enabled }: { enabled: boolean },
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [
      user?.uid,
      business?.id,
      ServerStateKeys.OrderDeliveryEvidence,
      orderId,
    ],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `orders/${orderId}/delivery-evidence`,
      }).then(
        (response) =>
          apiV2AssertResponse<OrderDeliveryEvidenceResponseType>(response).data,
      ),
    ...getDefaultQueryOptionsV2<OrderDeliveryEvidenceResponseType>({
      context: { scope: "business", user, business },
      options: {
        enabled,
        staleTime: 4 * 60 * 1000,
        refetchOnWindowFocus: true,
      },
    }),
  });
};
